import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService, IResponseLower } from '../../../shared/cardholders-core/services/http-service.service';
import { OtpResult } from '../interfaces/otp-result';
import { OtpRequest } from '../interfaces/otp-request';
import { VerifyOtpRequest } from '../interfaces/verify-otp-request';
import { AppConfigsService } from '../../../config/app-configs.service';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class UploadFilesService {
    coveredMobileNumber: string;
    fullName: string;
    id: string = null;
    requestId: string = null;

    constructor(private httpSvc: HttpService, private appConfigSvc: AppConfigsService, private router: Router) {}

    getRequestSendOtp(request: OtpRequest): Observable<IResponseLower<OtpResult>> {
        return this.httpSvc.postLower(`${this.appConfigSvc.appConfigs.apiUrl}/deliveryUploadFiles/getrequestsendotp`, request);
    }

    verifyOtp(request: VerifyOtpRequest): Observable<IResponseLower<any>> {
        return this.httpSvc.postLower(`${this.appConfigSvc.appConfigs.apiUrl}/deliveryUploadFiles/verifyotp`, request);
    }

    goToMessage(msgType: string) {
        this.router.navigate(['/delivery-upload-files/failure'], { queryParamsHandling: 'merge', state: { type: msgType } });
    }

    uploadFiles(files: File[]): Observable<IResponseLower<any>> {
        const formData = new FormData();

        for (let i = 0; i < files.length; i++) {
            formData.append(files[i].name, files[i]);
        }

        return this.httpSvc.postLower(`${this.appConfigSvc.appConfigs.apiUrl}/deliveryUploadFiles/uploadFile`, formData);
    }
}
